'use strict';

var _classCallCheck = require("/home/solagro/htdocs/api.solagroteam.com/node_modules/@babel/runtime/helpers/classCallCheck");

module.exports = /*#__PURE__*/function () {
  function _class(key, path, parent, reference) {
    _classCallCheck(this, _class);

    this.key = key;
    this.path = path;
    this.parent = parent;
    this.reference = reference;
  }

  return _class;
}();